<template>
	<p class="note"><strong>Note: </strong><slot /></p>
</template>

<script>
export default { name: 'Note' }
</script>

<style lang="scss" scoped>
@import '~scss/vars';

.note {
	font-style: italic;
	color: $grey-32;
}
</style>
